import { EventBus } from 'OK/EventBus';

type SerializedPayload = string;

type EventType = 'click' | 'seen';

export const EVENT_TYPE: Record<string, EventType> = {
    CLICK: 'click',
    SEEN: 'seen',
};

export interface ILogListenerEventTriggeredParams {
    // Какой тип события сработал: клик или показ.
    type: typeof EVENT_TYPE[keyof typeof EVENT_TYPE];
    payload: SerializedPayload;
}

function create<T>(name: string) {
    return EventBus.create<T>({
        prefix: 'logListener',
        name
    });
}

/**
 * "Произошло пользовательское событие".
 */
export const EVENT_TRIGGERED = create<ILogListenerEventTriggeredParams>('trigger');
